import { configureStore } from '@reduxjs/toolkit';
import {
  useDispatch as useAppDispatch,
  useSelector as useAppSelector,
  TypedUseSelectorHook,
} from 'react-redux';
import userSlice from '@/redux/slices/user.slice';
import referralsSlice from '@/redux/slices/referrals.slice';
import appointmentsSlice from '@/redux/slices/appointments.slice';

import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from 'redux';
import patientsSlice from '@/redux/slices/patients.slice';
import patientSlice from '@/redux/slices/patient.slice';
import autoregistrySlice from '@/redux/slices/autoregistry.slice';
import notificationsSlice from '@/redux/slices/notifications.slice';
import diarySlice from '@/redux/slices/diary.slice';
import emotionalTrackSlice from '@/redux/slices/emotional-track.slice';
import informedConsentSlice from '@/redux/slices/informed_consent.slice';
import otherDocumentationSlice from '@/redux/slices/other_documentation.slice';
import changesHistorySlice from '@/redux/slices/changes_history.slice';
import resourcesSlice from '@/redux/slices/resources.slice';
import appSlice from '@/redux/slices/app.slice';

const persistConfig = {
  key: 'root',
  storage, 
};

const rootReducer = combineReducers({
  app: appSlice,
  user: userSlice,
  referrals: referralsSlice,
  appointments: appointmentsSlice,
  patients: patientsSlice,
  patient: patientSlice,
  autoregistry: autoregistrySlice,
  notifications: notificationsSlice,
  diary: diarySlice,
  emotionalTrack: emotionalTrackSlice,
  informedConsent: informedConsentSlice,
  otherDocumentation: otherDocumentationSlice,
  changesHistory: changesHistorySlice,
  resources: resourcesSlice,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);

export type AppState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const { dispatch } = store;
export const useDispatch = () => useAppDispatch<AppDispatch>();
export const useSelector: TypedUseSelectorHook<AppState> = useAppSelector;

export default store;
